/**
 * AboutResponsesPage — explainer for why Rocky can produce incorrect or
 * misleading responses, linked from the "Rocky is AI and can make mistakes."
 * disclaimer below the chat composer.
 *
 * Modeled on assistant-vendor help articles (e.g. Anthropic's "Claude is
 * providing incorrect or misleading responses" support page), adapted for
 * Rocky as an internal Amazon agent that uses tools, skills, and internal data.
 */

import { useTranslation } from 'react-i18next';

import SafeTrans from '../../i18n/SafeTrans';
import './AboutResponsesPage.css';

const WHY = ['why1', 'why2', 'why3', 'why4'] as const;
const WHAT_TO_DO = ['do1', 'do2', 'do3', 'do4'] as const;

export default function AboutResponsesPage() {
  const { t } = useTranslation('settings');
  const item = (key: (typeof WHY)[number] | (typeof WHAT_TO_DO)[number]) => (
    <li key={key}>
      <SafeTrans t={t} i18nKey={`about.${key}`} components={{ strong: <strong /> }} />
    </li>
  );
  return (
    <div className="about-responses">
      <article className="about-responses__article">
        <h1 className="about-responses__title">{t('about.title')}</h1>

        <p className="about-responses__lede">{t('about.lede')}</p>

        <section className="about-responses__section">
          <h2 className="about-responses__heading">{t('about.whyHeading')}</h2>
          <ul className="about-responses__list">{WHY.map(item)}</ul>
        </section>

        <section className="about-responses__section">
          <h2 className="about-responses__heading">{t('about.doHeading')}</h2>
          <ul className="about-responses__list">{WHAT_TO_DO.map(item)}</ul>
        </section>

        <p className="about-responses__footnote">{t('about.footnote')}</p>
      </article>
    </div>
  );
}
